// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"18e10734","179":"3c5568fb","228":"ef8fa907","272":"8ec62dfe","352":"1a75dd4b","549":"5bceb1d0","666":"b2c655b9","816":"1156e6f1","930":"0b18930c","996":"61afcaeb"}[chunkId] + ".chunk.js";
};